import type { SavedTwapOrder } from '@/domain/WorkspaceForex/savedProducts/order/SavedTwapOrder.ts';
import type { TwapOrder } from '@/store/orders/algoOrders/state.ts';

export const mapToTwap = (savedTile: SavedTwapOrder): TwapOrder => {
  return {
    ...savedTile,
    properties: {
      ...savedTile.properties,
    },
  };
};
